"use strict";

window.ResourceSections = {
  creditCardErrors: "creditCardErrorMessages",
  defaultError: "MCC_1"
};